import { AnalysisType } from "./analysis-type";

export class SampleRedoDTO{
    analysisType: boolean;
    reRunCount: boolean;
    sampleIdList: Array<SampleWithAnalysisType>;
}

export class SampleWithAnalysisType {
    sampleID:string;
    type:AnalysisType;
}